import React from "react";
import { Button } from "react-bootstrap";

export const ExportButton = (props) => {
  const { exportFunc, isDisabled } = props;
  return (
    <div className="mb-3 d-flex justify-content-end">
      <span className={isDisabled ? "cursor-not-allowed" : ""}>
        <Button
          data-testid="export-button"
          className="green-background-color green-border"
          disabled={isDisabled}
          onClick={() => exportFunc()}
        >
          Export
        </Button>
      </span>
    </div>
  );
};
